import React, { useEffect, useState } from "react";
import DRMDiary from "../New diary/DRMDiary";
import axios from "axios";
import Loading from "../../../Extra/Loading";

const API_URL = process.env.REACT_APP_URL_PREFIX || "";

const CompsMaster = () => {
  const [loading, setLoading] = useState(false);
  const [downLoading, setDownLoading] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [data, setData] = useState([]);
  const [error, setError] = useState("");

  const fetchData = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await axios.get(
        `${API_URL}msg/drm_documents?category=DRM_Diary`,
      );

      const diaries = Array.isArray(response.data?.data)
        ? response.data.data
        : [];

      setData(diaries);
    } catch (err) {
      console.error("Error fetching DRM diaries:", err);
      setError("Unable to load DRM Diary. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  // Latest diary
  const latestDiary = data[0];

  // Previous diaries
  const previousDiaries = data
    .filter((diary) => !diary.isLatest)
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

  // Download diary PDF

  const handleDownload = async (diary) => {
    if (!diary?.download_url) {
      console.warn("PDF URL not available");
      return;
    }

    setDownLoading(true);
    setDownloadProgress(0);

    try {
      const response = await axios.get(diary.download_url, {
        responseType: "blob",

        onDownloadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            );

            setDownloadProgress(percent);
          }
        },
      });

      const blob = new Blob([response.data], {
        type: response.headers["content-type"] || "application/pdf",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = diary.file_name || "DRM_Diary.pdf";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Unable to download the diary. Please try again.");
    } finally {
      setDownLoading(false);
      setDownloadProgress(0);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div>
      {loading && <Loading />}

      {!loading && error && (
        <div className="alert alert-danger text-center m-3">
          {error}
          <button
            className="btn btn-sm btn-outline-danger ms-3"
            onClick={fetchData}
          >
            Retry
          </button>
        </div>
      )}

      {!loading && !error && (
        <>
          <DRMDiary
            currentDiary={latestDiary}
            diaries={previousDiaries}
            onDownload={handleDownload}
            downLoading={downLoading}
            downloadProgress={downloadProgress}
            title="DRM Diary"
            subtitle="Jabalpur Division | Monthly Diary & Document Archive"
          />
        </>
      )}
    </div>
  );
};

export default CompsMaster;
